import AppUpdateDetector from "@components/utils/AppUpdateDetector";
import MemberSettingsLoader from "@components/utils/MemberSettingsLoader";
import ThemeColorLoader from "@components/utils/ThemeColorLoader";
import { sentryManual } from "@configs/sentry/manual-sentry";
import { AppStatsigProvider } from "@configs/statsig/StatsigProvider";
import { ThemePreset } from "@configs/theme-preset";
import * as Sentry from "@sentry/react";
import { store } from "@stores";
import "@styles/App.css";
import { initDesktopBlocker } from "@utils/desktop-blocker";
import { ThemeProvider } from "kz-ui-sdk";
import "kz-ui-sdk/dist/sdk-themes.css";
import "react-aspect-ratio/aspect-ratio.css";
import { Provider } from "react-redux";
import AppRoutes from "./AppRouter";
import ErrorFallback from "./ErrorFallback";
import "./configs/i18n";

const desktopBlockerRes = initDesktopBlocker();
if (desktopBlockerRes.shouldBlock) {
  const sentryEventAdditionalData: Record<string, any> = {
    blockerEnabled: false,
    blockReason: desktopBlockerRes.context.blockReason,
    context: {
      ...desktopBlockerRes.context.criteria,
      userAgent: desktopBlockerRes.context.userAgent,
      screenSize: `${window.innerWidth}x${window.innerHeight}`,
    },
  };
  sentryManual.captureMessage("Desktop blocker", "warning", sentryEventAdditionalData);
}

function App() {
  return (
    <ThemeProvider
      value={{
        preset: ThemePreset,
      }}
    >
      <Provider store={store}>
        <ThemeColorLoader />
        <MemberSettingsLoader>
          <AppStatsigProvider>
            <AppRoutes />
          </AppStatsigProvider>
        </MemberSettingsLoader>
        <AppUpdateDetector />
      </Provider>
    </ThemeProvider>
  );
}

export const EnhancedApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }: { error: unknown; resetError: () => void }) => (
    <ErrorFallback
      error={error}
      resetError={resetError}
    />
  ),
});

export default App;
